import React from 'react'

export const MenuStyles: { [key: string]: React.CSSProperties } = {
    container: {
        flex: 1,
        height: 58,
        paddingLeft: 20,
        display: 'flex',
        paddingRight: 20,
        alignItems: 'center',
        backgroundColor: '#2699D6',
        justifyContent: 'space-between',
    },
    itemsContent: { display: 'flex', alignItems: 'center' },
    divider: {
        width: 1,
        height: 40,
        marginLeft: 15,
        marginRight: 15,
        backgroundColor: '#184287',
    },
    ml10: { marginLeft: 10 },
    suscriptionBtn: {
        height: '100%',
        display: 'flex',
        paddingLeft: 10,
        paddingRight: 10,
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    chatBtn: {
        display: 'flex',
        borderRadius: 7,
        paddingRight: 15,
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid white',
        backgroundColor: 'transparent',
    },
    chatBtnIconContainer: {
        borderRight: '1px solid white',
        paddingBottom: 5,
        paddingRight: 10,
        paddingLeft: 10,
        marginRight: 15,
        paddingTop: 5,
    },
    flagContainer: {
        width: 45,
        height: 45,
        display: 'flex',
        borderRadius: 45,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#184287',
    },
    imageCircleContainer: {
        width: 45,
        height: 45,
        marginLeft: 5,
        borderRadius: 45,
        backgroundColor: '#184287',
    },
    flagsContainer: { marginLeft: 10, display: 'flex' },
    menuContainer: {
        height: 20,
        display: 'flex',
        cursor: 'pointer',
        flexDirection: 'column',
        backgroundColor: 'transparent',
        justifyContent: 'space-between',
    },
    menuIconItem: {
        width: 32,
        height: 3,
        borderRadius: 5,
        backgroundColor: '#fff',
    },
}
